import { urlEncodeUtil } from 'helpers/url-encode';
import { PaginationInput, PaginationOutput } from 'kl-b2c-ui-kit';
import { HttpResponse, IApiService, ISpeakersApi, Speaker, Tag } from 'types';

export class SpeakersApi implements ISpeakersApi {
    constructor(private readonly apiService: IApiService) {}

    public getAll(params: PaginationInput & { tagIds: string[] }): Promise<HttpResponse<PaginationOutput<Speaker>>> {
        return this.apiService.request<PaginationOutput<Speaker>>({
            method: 'GET',
            url: `/speakerContent/get`,
            params,
            paramsSerializer: urlEncodeUtil,
        });
    }

    public getTags({ page, size }: PaginationInput): Promise<HttpResponse<PaginationOutput<Tag>>> {
        return this.apiService.request<PaginationOutput<Tag>>({
            method: 'GET',
            url: `/speakerContentTag/get?page=${page}&size=${size}&withSpeakers=true`,
        });
    }
}
